import React from 'react'
import Page from './page'
import './press.css'

function Press () {
  return (
    <Page>
      <header className="press-header">
        <h1>Press</h1>
      </header>
      <section className="press-list">
        <p>
          “Hunter Adam’s Dig Two Graves is that rare chiller conjuring eeriness and dread”
          <br />
          <a href="https://www.nytimes.com/2017/03/23/movies/dig-two-graves-review.html" target="_blank" rel="noopener noreferrer">- Andy Webster, The New York Times</a>
        </p>
        <p>
          “Creepy Thriller Dig Two Graves evokes the best of Stephen King”
          <br />
          <a href="http://www.latimes.com/entertainment/movies/la-et-mn-mini-dig-two-graves-review-20170323-story.html" target="_blank" rel="noopener noreferrer">- Noel Murray, Los Angeles Times</a>
        </p>
        <p>
          “An uncommonly smart, well-made and ultimately touching meditation on grief, revenge and the ordinary perils of adolescence”
          <br />
          <a href="http://www.rogerebert.com/reviews/dig-two-graves-2017" target="_blank" rel="noopener noreferrer">- Peter Sobczynski, Roger Ebert.com</a>
        </p>
        <p>
          “A stylish haunting thriller...dark, original and chilling”
          <br />
          <a href="http://chicago.suntimes.com/entertainment/dig-two-graves/" target="_blank" rel="noopener noreferrer">- Richard Roeper, Chicago Sun-Times</a>
        </p>
        <p>
          “Gripping horror-thriller, handsomely wrought”
          <br />
          <a href="https://www.washingtonpost.com/goingoutguide/movies/dig-two-graves-is-a-flawed-but-gorgeously-gripping-horror-thriller/2017/03/23/7de1ba24-0bf0-11e7-b77c-0047d15a24e0_story.html" target="_blank" rel="noopener noreferrer">- Jane Horwitz, Washington Post</a>
        </p>
        <p>
          “Dig Two Graves is handsomely accomplished in all departments”
          <br />
          <a href="http://variety.com/2017/film/reviews/dig-two-graves-film-review-1202013784" target="_blank" rel="noopener noreferrer">- Dennis Harvey, Variety</a>
        </p>
        <p>
          “Stylish gothic tale of revenge”
          <br />
          <a href="http://www.dailyherald.com/article/20170323/entlife/170329584/" target="_blank" rel="noopener noreferrer">- Dann Gire, Daily Herald</a>
        </p>
        <p>
          “Dig Two Graves is an amazing thriller of a film”
          <br />
          <a href="http://bloody-disgusting.com/reviews/3428747/review-dig-two-graves-unearths-wonderful-acting-story/" target="_blank" rel="noopener noreferrer">- Pat Torfe, BloodyDisgusting.com</a>
        </p>
        <p>
          “…contains a star-making performance from Samantha Isler.”
          <br />
          <a href="https://www.flickeringmyth.com/2017/03/movie-review-dig-two-graves-2017/" target="_blank" rel="noopener noreferrer">- Robert Kojder, Chief Film Critic of Flickering Myth.</a>
        </p>
        <p>
          “Beautifully shot and hauntingly atmospheric though it may be, the film is built on the performances from Isler and Levine”
          <br />
          <a href="http://collider.com/dig-two-graves-review/#images" target="_blank" rel="noopener noreferrer">- Haleigh Foutch, Collider</a>
        </p>
        <p>
          “Incredible performances delivered by Samantha Isler and Ted Levine”
          <br />
          <a href="http://www.joblo.com/horror-movies/news/dig-two-graves-movie-review-306" target="_blank" rel="noopener noreferrer">- Cody Hamman Joblo</a>
        </p>
        <p>
          “DIG TWO GRAVES is an undiscovered gem, a small masterpiece that should not be missed.”
          <br />
          <a href="http://horrornews.net/95347/film-review-dig-two-graves-2014" target="_blank" rel="noopener noreferrer">- Horror News</a>
        </p>
        <p>
          “If you are in the mood for something decidedly unique, put this film high on your need-to-see list.”
          <br />
          <a href="http://gruesomemagazine.com/2015/10/09/dig-two-graves-2014-gothic-chiller-serves-up-first-rate-storytelling-and-superb-performances" target="_blank" rel="noopener noreferrer">- Gruesome Magazine</a>
        </p>
        <p>
          “DIG TWO GRAVES ladles over a tightly-paced mystery with an inky dose of the supernatural, etched deep with a sense of place as pungent as pine pitch and deer flesh.”
          <br />
          <a href="http://neworleansfilmsociety.org/film/info/2096/dig-two-graves" target="_blank" rel="noopener noreferrer">- New Orleans Film Society</a>
        </p>
        <p>
          “DIG TWO GRAVES is a rare genre drama that strays from sentimentality to deliver a suspenseful story executed with powered precision.”
          <br />
          <a href="http://culturecrypt.com/movie-reviews/dig-two-graves-2014" target="_blank" rel="noopener noreferrer">- Culture Crypt</a>
        </p>
        <p>
          “Director Hunter Adams interviewed about the making of DIG TWO GRAVES.”
          <br />
          <a href="http://iaemagazine.com/featured/hunter-adams-talks-dig-two-graves" target="_blank" rel="noopener noreferrer">- IAE Magazine</a>
        </p>
      </section>
      <section className="press-downloads">
        <p>
          <a className="button" href="https://hydrostudios.app.box.com/s/6k8xzs46efajr2xzxmfo8xe3ar2fuuv2" target="_blank" rel="noopener noreferrer">Download Press Kit</a>
        </p>
      </section>
    </Page>
  )
}

export default Press



// WEBPACK FOOTER //
// ./src/components/press.js